var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKumuduU(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 319,
    viewBox: "0 0 148 319",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.5 126.405H74V271.905H80.5V126.405Z",
    fill: "#218992"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109.522 193.905C117.522 177.505 138.188 168.072 147.522 165.405V270.905C143.522 310.505 103.188 319.405 83.5218 318.905C20.7218 319.305 6.35515 287.072 7.02182 270.905V165.405C24.2218 167.805 39.5218 185.405 45.0218 193.905V261.905C45.0218 273.405 58.5218 289.405 83.5218 286.405C103.522 284.005 109.188 269.072 109.522 261.905V193.905Z",
    fill: "#1E8B90"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2769 164.405C88.2769 143.238 102.277 99.6049 142.277 94.4049C141.277 114.405 128.677 156.405 86.2769 164.405Z",
    fill: "#218996"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0061 164.993C47.9163 158.034 8.84346 134.093 13.2705 94C32.4639 99.711 70.2817 121.905 68.0061 164.993Z",
    fill: "#218996"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M92 93.5L108 30H117.5L124.5 37L131 30H143.5C126.7 42 102.167 77.3333 92 93.5Z",
    fill: "#B1B1B5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5 0H45L61 19L78.5 0Z",
    fill: "#B1B1B5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M98 30H66L81 93.5L98 30Z",
    fill: "#B1B1B5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M123.5 3.5L109 22H118.5L123.5 13.5L131.5 22H144L123.5 3.5Z",
    fill: "#B1B1B5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M115 0H83L100.5 18.5L115 0Z",
    fill: "#B1B1B5"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M17 22.5L37 3.5L52.5 22.5H17Z",
    fill: "#B1B1B5"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5 29.5H17L35.5 45.5L41.5 39.5L48 47.5L41.5 53C46.7 58.2 62 82.1667 69 93.5L53.5 29.5Z",
    fill: "#B1B1B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKumuduU);
export default __webpack_public_path__ + "static/media/kumudu_U.45e01678d84d148f59b941ebeb63863d.svg";
export { ForwardRef as ReactComponent };